import { EvaluationFrontendParameter } from './EvaluationFrontendParameter.model';
import { TrainEvaluationParameters } from './TrainAndDoorList.model';

export class TrainEvaluationFrontendParameter extends EvaluationFrontendParameter {
    trainEvaluationParameters:TrainEvaluationParameters[];
}